export default "/_next/static/images/hyperlink-icon-1f33d2f744ccb546c8dc76be80edecfc.png";